import { FormAdapterBase } from '../form-adapter-base';
import { FormArray, FormGroup, FormControl } from '@angular/forms';

export class PreviousEntityAdapter<T extends FormGroup> extends FormAdapterBase<T, FormArray> {

    /*
    * Takes a formArray of length 2 (length can be more than 2, but it has no effect on those)
    * Disables the second if the duration at the first is more than x years (n months)
    *
    * */

    private readonly endDateKey: string;

    private readonly n: number;

    private readonly startDateKey: string;

    public constructor(
        form: T,
        basePath: string,
        startDateKey = 'startDate',
        endDateKey = 'endDate',
        n = 24,
    ) {
        super(form, basePath);
        this.n = n;
        this.startDateKey = startDateKey;
        this.endDateKey = endDateKey;
    }

    public override apply(): void {
        if (this.getTargetForm().length > 1) {
            const currentEntity = this.getTargetForm().at(0) as T;
            const startDateControl = currentEntity.get(this.startDateKey) as FormControl;
            const endDateControl = currentEntity.get(this.endDateKey) as FormControl;

            this.checkAndTogglePreviousEntity(startDateControl!.value || '', endDateControl!.value || '');
        }
    }

    private calculateDuration(startDate: string, endDate: string | null): number {
        const start = new Date(startDate);
        const end = endDate ? new Date(endDate) : new Date();
        const duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24 * 30.44); // Convert to months
        return Math.floor(duration);
    }

    private checkAndTogglePreviousEntity(startDate: string, endDate: string | null): void {
        const form = this.getTargetForm();
        const control = form.at(1);
        const duration = this.calculateDuration(startDate, endDate);
        if (duration === 0) { // Handle edge case because 0 is considered falsy
            control.disabled && control.enable();
        } else if (!duration || duration >= this.n) {
            control.enabled && control.disable();
        } else {
            control.disabled && control.enable();
        }
    }
}
